var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-grid',{attrs:{"cols":_vm.cols}},_vm._l((_vm.cells),function(c,i){return _c('v-grid-cell',{key:i,attrs:{"span":c.span}},[_vm._t("default",null,{"index":i}),_vm._v("\n    "+_vm._s(c.text)+"\n  ")],2)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }